import $ from 'jquery';
// import '../../../../../bower_components/bootstrap-tabcollapse/bootstrap-tabcollapse';
import 'bootstrap-tabcollapse';
import {resizeCards} from './cartes-accessoires';


var whiteCard = '.containOffresFinancement .whiteCard';
var greyCard = '.containCartesAccessoires:not(.inModal) .greyCard';

function collapseAccordionFiche() {
    $('.accordiontoHide .panel-collapse').removeClass('in');
    $('.accordiontoHide .panel-heading a').addClass('collapsed');
}

$(document).ready(function () {
    $('#infosFicheVehiculeTabs').tabCollapse({
        tabsClass: 'hidden-xs hidden-sm hidden-md',
        accordionClass: 'visible-sm visible-xs visible-md accordiontoHide'
    });

    $('a[aria-controls="fiche-infos-personnalisation"]').on('shown.bs.tab', function () {
        resizeCards(greyCard, 50);
    });

    $('#modalTunnelDevis').on('shown.bs.modal', function () {
        resizeCards('.containCartesAccessoires.inModal .greyCard', 50);
        $('#modalTunnelDevis').modal('handleUpdate');
    });

    $('#fiche-infos-personnalisation-collapse').on('shown.bs.collapse', function () {
        resizeCards(greyCard, 40);
    });

    setTimeout(function () {
        collapseAccordionFiche();
    }, 100);

    $(document).on('shown.bs.collapse shown.bs.tab', '.panel-collapse', function () {
        $('.inputSlider').slider('relayout');
    });


// $('#infosFicheVehiculeTabs, #infosFicheVehiculeTabs-accordion').on('shown.bs.collapse shown.bs.tab', function (e) {
    $('#infosFicheVehiculeTabs-accordion').on('shown.bs.collapse shown.bs.tab', function (e) {
        if ($(e.target).hasClass('panel-collapse')){
            $('html,body').animate({
                scrollTop: $(e.target).offset().top -110
            }, 500);
        }
    });
});




